const RobotSumoWinnersList: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <section className="mb-8">
                <p className="mb-2">
                    Kompetisi <b>Robot Sumo</b> dalam ajang <b>Indonesia Innovative Technology Challenge (IIT Challenge) 2024</b> telah berlangsung dengan penuh semangat dan ketegangan.
                    Kategori ini menantang peserta untuk merancang, membangun, dan memprogram robot yang mampu bertarung di arena pertandingan layaknya pertarungan sumo tradisional.
                </p>

                <p className="mb-2">Setelah melalui babak penyisihan yang ketat, berikut adalah para juara yang berhasil mencatatkan prestasi gemilang:
                </p>

                <p className='mb-3'><b>🏆 Pemenang Coding Python Junior 2024</b></p>
                <ul className="list-disc pl-6 mb-4">
                    <li>
                        <p className='mb-2 font-semibold'>🥇 Juara 1 – Tim Refraction</p>
                        <ul className='ml-8'>
                            <li className='font-semibold'>•	Edward Putra Rusli</li>
                            <li className='font-semibold'>•	Gregorius Nathaniel Perdana Budihartono</li>
                            <p><i>(SMAK 1 BPK Penabur Jakarta)</i></p>
                        </ul>
                    </li>

                    <li>
                        <p className='mb-2 font-semibold'>🥈 Juara 2 – Tim SLOW TEAM</p>
                        <ul className='ml-8'>
                            <li className='font-semibold'>•	Azam Zahran Razzaq</li>
                            <li className='font-semibold'>•	Alwan Abqory Winesa</li>
                            <p><i>(MTsN Jakarta)</i></p>
                        </ul>
                    </li>
                </ul>

                <p className="mb-4 font-semibold">⚙️ TANTANGAN SUMO ROBOT</p>
                <p className='mb-3'>Kompetisi ini menguji berbagai aspek, termasuk:</p>
                <ul className='ml-8 mb-4'>
                    <li>• <b>Desain & Kekuatan Robot:</b> Kemampuan robot untuk tetap stabil dan kuat di arena.</li>
                    <li>• <b>Strategi & Kecerdasan Buatan:</b> Pemrograman robot untuk mengenali lawan dan mengambil keputusan cepat.</li>
                    <li>• <b>Ketahanan & Adaptasi:</b> Robot harus mampu bertahan dalam berbagai situasi pertarungan.</li>
                </ul>
                <p className='mb-3'><b>Tim Refraction</b> berhasil menunjukkan keunggulan dalam semua aspek tersebut, sementara <b>SLOW TEAM </b>memberikan persaingan sengit dengan strategi yang matang.</p>

                <p className="mb-4 font-semibold">Hadiah & Manfaat Eksklusif untuk Para Pemenang:</p>

                <p className='mb-3'>Selain medali dan sertifikat penghargaan, para pemenang berhak mendapatkan <b>benefit bernilai total ratusan juta rupiah</b>, termasuk:</p>

                <p className="mb-4 font-semibold">💻 Pelatihan Teknologi</p>

                <ul className="list-disc pl-6 mb-3">
                    <li>✅ Software Programming Bootcamp (2 Bulan) – Senilai Rp 26.550.000</li>
                    <li>✅ Robotic Race Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Software Programming Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Subsidi Biaya Pendaftaran WIT Challenge 2024</li>
                </ul>

                <p className="mb-3 font-semibold">🎓 Beasiswa UKRIDA</p>
                <ul className="list-disc pl-6 mb-4">
                    <li><b>Juara 1:</b> Beasiswa penuh (SPP + uang pangkal) hingga 8 semester di Teknik Elektro, Industri, atau Sipil (IPK ≥ 3.00). Prodi lain: Gratis uang pangkal + diskon 25% SPP.</li>
                    <li><b>Juara 2:</b> Gratis uang pangkal 100% untuk semua prodi.</li>
                    <li><b>Juara 3:</b> Diskon 70% uang pangkal untuk semua prodi.</li>
                    <li><b>Semua Juara:</b> Biaya pangkal Kedokteran khusus Rp 200.000.000 (kuota Ukridian&apos;s Family, syarat berlaku).</li>
                </ul>

                <p className='mb-2 font-semibold'>🌟 PESAN INSPIRATIF</p>
                <p className="mb-2">Kompetisi ini bukan hanya tentang kemenangan, tetapi juga tentang <b>belajar, berkolaborasi, dan berinovasi.</b> Setiap peserta telah membuktikan bahwa robotik adalah bidang yang penuh dengan kreativitas dan tantangan.</p>

                <p className='mb-2 font-semibold'>📢 Ikuti Jejak Mereka!</p>
                <p className="mb-2">Saksikan momen seru kompetisi di Instagram <a className='text-blue-500' href='https://www.instagram.com/iitchallenge2024/#'>@iitchallenge2024</a>.</p>

                <p className="mb-4 font-semibold">Mari dukung generasi muda Indonesia untuk terus berkarya di dunia robotik dan teknologi! 🤖🚀</p>
            </section>
        </div>
    )
}
export default RobotSumoWinnersList